/**
 * MarkdownRenderer — renders markdown content using react-markdown.
 * Strips YAML frontmatter, supports GFM tables/task-lists, and syntax highlighting.
 */
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkFrontmatter from 'remark-frontmatter';
import rehypeHighlight from 'rehype-highlight';
import 'highlight.js/styles/github-dark.min.css';

const plugins = {
  remarkPlugins: [remarkGfm, remarkFrontmatter],
  rehypePlugins: [rehypeHighlight],
};

export default function MarkdownRenderer({ children, className = '', style = {} }) {
  if (!children) return null;

  return (
    <div className={`markdown-renderer ${className}`} style={style}>
      <Markdown {...plugins}>{children}</Markdown>
    </div>
  );
}
